import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @file 全局 loading 组件
 */
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import styled, { useTheme } from 'styled-components';
import { Icon } from '../../Icon';
export const LoadingGlobal = ({ message }) => {
    const theme = useTheme();
    return (_jsxs(Loading, { children: [_jsx(Icon, { icon: faSpinnerThird, spin: true, style: { fontSize: 40, animationDuration: '1s' }, color: theme.brand._1 }, void 0), message && _jsx(LoadingMessage, { children: message }, void 0)] }, void 0));
};
const Loading = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;
`;
const LoadingMessage = styled.span `
  margin-top: 20px;
  color: ${p => p.theme.text._1};
  font-weight: bold;
  font-size: 16px;
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTG9hZGluZ0dsb2JhbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9TdGF0ZS9zaG93R2xvYmFsTG9hZGluZy9Mb2FkaW5nR2xvYmFsLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7O0dBRUc7QUFFSCxPQUFPLEVBQUUsY0FBYyxFQUFFLE1BQU0sb0NBQW9DLENBQUE7QUFFbkUsT0FBTyxNQUFNLEVBQUUsRUFBRSxRQUFRLEVBQUUsTUFBTSxtQkFBbUIsQ0FBQTtBQUVwRCxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0sWUFBWSxDQUFBO0FBRWpDLE1BQU0sQ0FBQyxNQUFNLGFBQWEsR0FBbUMsQ0FBQyxFQUFFLE9BQU8sRUFBRSxFQUFFLEVBQUU7SUFDM0UsTUFBTSxLQUFLLEdBQUcsUUFBUSxFQUFFLENBQUE7SUFDeEIsT0FBTyxDQUNMLE1BQUMsT0FBTyxlQUNOLEtBQUMsSUFBSSxJQUNILElBQUksRUFBRSxjQUFjLEVBQ3BCLElBQUksRUFBRSxJQUFJLEVBQ1YsS0FBSyxFQUFFLEVBQUUsUUFBUSxFQUFFLEVBQUUsRUFBRSxpQkFBaUIsRUFBRSxJQUFJLEVBQUUsRUFDaEQsS0FBSyxFQUFFLEtBQUssQ0FBQyxLQUFLLENBQUMsRUFBRSxXQUNyQixFQUNELE9BQU8sSUFBSSxLQUFDLGNBQWMsY0FBRSxPQUFPLFdBQWtCLFlBQzlDLENBQ1gsQ0FBQTtBQUNILENBQUMsQ0FBQTtBQUVELE1BQU0sT0FBTyxHQUFHLE1BQU0sQ0FBQyxHQUFHLENBQUE7Ozs7O0NBS3pCLENBQUE7QUFFRCxNQUFNLGNBQWMsR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFBOztXQUV2QixDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLEVBQUU7OztDQUc5QixDQUFBIn0=